/* OS — porto #cloud_search_filters_root sulla riga del menu desktop dell'header. */
(function () {
  var osCsMq = window.matchMedia('(min-width: 990px)');
  var osCsHome = null;

  function osCsSlot() {
    return document.querySelector('[data-os-cs-filters-slot]');
  }

  function osCsFreshRoot() {
    var roots = document.querySelectorAll('#cloud_search_filters_root');
    for (var i = 0; i < roots.length; i++) {
      if (!roots[i].closest('[data-os-cs-filters-slot]')) return roots[i];
    }
    return null;
  }

  function osCsRestore() {
    var slot = osCsSlot();
    var moved = slot && slot.querySelector('#cloud_search_filters_root');
    if (moved && osCsHome && osCsHome.parentNode) {
      osCsHome.parentNode.replaceChild(moved, osCsHome);
    }
    osCsHome = null;
  }

  function osCsPlace() {
    var slot = osCsSlot();
    if (!slot) return;
    var fresh = osCsFreshRoot();
    var moved = slot.querySelector('#cloud_search_filters_root');
    if (fresh && moved) moved.remove(); // root ricreato dalla sezione o dall'app
    if (!osCsMq.matches) {
      osCsRestore();
      return;
    }
    if (fresh) {
      osCsHome = document.createComment('os-cs-root');
      fresh.parentNode.insertBefore(osCsHome, fresh);
      slot.appendChild(fresh);
    }
  }

  osCsPlace();
  osCsMq.addEventListener('change', osCsPlace);
  document.addEventListener('shopify:section:load', osCsPlace);
  document.addEventListener('shopify:section:unload', osCsRestore);
  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) {
        osCsPlace();
        return;
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
